"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.replace");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TextAdapter = _interopRequireDefault(require("./TextAdapter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var WholeNumberAdapter = /*#__PURE__*/function (_React$Component) {
  _inherits(WholeNumberAdapter, _React$Component);

  var _super = _createSuper(WholeNumberAdapter);

  function WholeNumberAdapter() {
    var _this;

    _classCallCheck(this, WholeNumberAdapter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_handlePaste", function (e) {
      var onPaste = _this.props.onPaste;
      e.preventDefault();
      var pastedInput = e.clipboardData.getData('text/plain').replace(/\D/g, '');
      document.execCommand('insertText', false, pastedInput);
      onPaste(e);
    });

    _defineProperty(_assertThisInitialized(_this), "_handleKeyDown", function (e) {
      _this.props.onKeyDown(e);

      if ( // Allow: Delete, Backspace, Tab, Escape, Enter
      [46, 8, 9, 27, 13].indexOf(e.keyCode) !== -1 || e.keyCode === 65 && e.ctrlKey === true || // Allow: Ctrl+A
      e.keyCode === 67 && e.ctrlKey === true || // Allow: Ctrl+C
      e.keyCode === 86 && e.ctrlKey === true || // Allow: Ctrl+V
      e.keyCode === 88 && e.ctrlKey === true || // Allow: Ctrl+X
      e.keyCode === 65 && e.metaKey === true || // Cmd+A (Mac)
      e.keyCode === 67 && e.metaKey === true || // Cmd+C (Mac)
      e.keyCode === 86 && e.metaKey === true || // Cmd+V (Mac)
      e.keyCode === 88 && e.metaKey === true || // Cmd+X (Mac)
      e.keyCode >= 35 && e.keyCode <= 39 // Home, End, Left, Right
      ) {
          return; // let it happen, don't do anything
        } // Ensure that it is a number and stop the keypress


      if ((e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_handleDrop", function (e) {
      e.preventDefault();
      var textData = e.dataTransfer.getData('text').replace(/\D/g, '');
      e.target.focus();
      document.execCommand('insertText', false, textData);

      _this.props.onDrop(e);
    });

    return _this;
  }

  _createClass(WholeNumberAdapter, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_TextAdapter.default, _extends({}, this.props, {
        onKeyDown: this._handleKeyDown,
        type: "number",
        onPaste: this._handlePaste,
        onDrop: this._handleDrop
      }));
    }
  }]);

  return WholeNumberAdapter;
}(_react.default.Component);

exports.default = WholeNumberAdapter;

_defineProperty(WholeNumberAdapter, "propTypes", {
  field: _propTypes.default.object.isRequired,
  onKeyDown: _propTypes.default.func,
  onPaste: _propTypes.default.func,
  onDrop: _propTypes.default.func
});

_defineProperty(WholeNumberAdapter, "defaultProps", {
  onKeyDown: function onKeyDown() {},
  onPaste: function onPaste() {},
  onDrop: function onDrop() {}
});
//# sourceMappingURL=WholeNumberAdapter.js.map